import { Grid } from '@material-ui/core'
import BrandModelVersion from 'Components/UI/Organisms/Settings/Various/BrandModelVersion'
import Engine from 'Components/UI/Organisms/Settings/Various/Engine'
import Insurace from 'Components/UI/Organisms/Settings/Various/Insurance'
import Operators from 'Components/UI/Organisms/Settings/Various/Operators'

import Concepts from './Concepts'
import FamilyAndProducts from './FamilyAndProducts'
import LotsRow from './LotsRow'
import ProvinciesLocalitiesAddress from './ProvinciesLocalitiesAddress'
import Transport from './Transport'
import TypeVehicle from './TypeVehicle'
import UserInsurance from './UsersInsurance'
import Wafers from './Wafers'

const Varies = () => {
  return (
    <>
      <Grid container>
        <Grid item sm={4} xs={12}>
          <BrandModelVersion />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Insurace />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Transport />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Engine />
        </Grid>
        <Grid item sm={4} xs={12}>
          <FamilyAndProducts />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Operators />
        </Grid>
        <Grid item sm={4} xs={12}>
          <UserInsurance />
        </Grid>
        <Grid item sm={4} xs={12}>
          <TypeVehicle />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Concepts />
        </Grid>
        <Grid item sm={4} xs={12}>
          <LotsRow />
        </Grid>
        <Grid item sm={4} xs={12}>
          <ProvinciesLocalitiesAddress />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Wafers />
        </Grid>
      </Grid>
    </>
  )
}
export default Varies
